var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardTemplate',[(_vm.getRule === 'startup')?_c('StartupForm'):_vm._e(),(_vm.getRule === 'staff')?_c('StaffForm'):_vm._e(),(_vm.getRule === 'specialadmin')?_c('SpecialAdminForm'):_vm._e(),(_vm.getRule === 'admin')?_c('AdminForm'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }